import script from "./orderRequestHistoryForm.vue?vue&type=script&setup=true&lang=js"
export * from "./orderRequestHistoryForm.vue?vue&type=script&setup=true&lang=js"

import "./orderRequestHistoryForm.vue?vue&type=style&index=0&id=c44ae0f2&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c44ae0f2"]])

export default __exports__